// ─────────────────────────────────────────────────────────────────────
// HAS THE CLUB SAVED ITS OPENING HOURS? (owner decision 2026-10-31, #1192)
//
// No booking can be made until it has: every booking door on the server
// refuses `booking_hours_not_set` until the STORED `booking_config_v1` carries
// an opening and a closing time (`savedOpeningHours`, apps/api/src/lib/
// bookingPolicy.ts). The club portal asks the same question of the document it
// loaded, so it can say so BEFORE an operator's booking is refused.
//
// The same rule, written twice because the two packages share no module for
// it; `apps/api/tests/booking-hours-parity.test.ts` holds them to one answer.
// Read from the STORED document, never the merged config: the merge fills the
// engine's 07:00–23:00 in, and a default is not a save.
// ─────────────────────────────────────────────────────────────────────

const HHMM = /^([01]\d|2[0-3]):[0-5]\d$|^24:00$/;
const hhmm = (v: unknown): boolean => typeof v === 'string' && HHMM.test(v);

export function hasSavedBookingHours(stored: unknown): boolean {
  if (!stored || typeof stored !== 'object' || Array.isArray(stored)) return false;
  const doc = stored as Record<string, unknown>;
  return hhmm(doc.openTime) && hhmm(doc.closeTime);
}
